export default "__VITE_ASSET__DVf35Ozt__"